import React from 'react';
import { IonGrid, IonRow, IonCol } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { LuPiggyBank, LuWallet, LuTrendingUp, LuGift } from "react-icons/lu";
import AccountTypeCard from './AccountTypeCard';
import useCryptoMode from '@/hooks/useCryptoMode';

interface AccountSummaryProps {
    style?: React.CSSProperties;
    onCashClick?: () => void;
    onCryptoClick?: () => void;
    onSavingsClick?: () => void;
    onRewardsClick?: () => void;
}

export default function AccountSummary({ 
    style,
    onCashClick,
    onCryptoClick,
    onSavingsClick,
    onRewardsClick
}: AccountSummaryProps) {
    const { t } = useTranslation('components/accountSummary');
    const {cryptoMode} = useCryptoMode();

    const accounts = [
        {
            id: 'cash',
            title: t('cash'),
            icon: <LuWallet />,
            iconColor: '#2563eb', // blue-600
            onClick: onCashClick,
            assetType: 'fiat' as const,
            isComingSoon: false
        },
        {
            id: 'savings',
            title: t('savings'),
            icon: <LuPiggyBank />,
            iconColor: '#16a34a', // green-600  
            onClick: onSavingsClick,
            assetType: 'savings' as const,
            isComingSoon: true
        },
        {
            id: 'crypto',
            title: t('crypto'),
            icon: <LuTrendingUp />,
            iconColor: '#ea580c', // orange-600
            onClick: onCryptoClick,
            assetType: 'crypto' as const,
            isComingSoon: false
        },
        // {
        //     id: 'rewards',
        //     title: t('rewards'),
        //     icon: <LuGift />,
        //     iconColor: '#9333ea', // purple-600
        //     onClick: onRewardsClick,
        //     assetType: 'rewards' as const,
        //     isComingSoon: true
        // }
    ];

    return (
        <div className="w-full" style={style}>
            <IonGrid className="ion-no-padding">
                <IonRow>
                    {accounts
                        .filter((account) => {
                            // Hide crypto card when crypto mode is not active
                            if (account.id === 'crypto' && !cryptoMode) {
                                return false;
                            }
                            return true;
                        })
                        .map((account) => (
                            <IonCol size="6" key={account.id}>
                                <AccountTypeCard
                                    id={account.id}
                                    title={account.title}
                                    icon={account.icon}
                                    iconColor={account.iconColor}
                                    onClick={account.onClick}
                                    assetType={account.assetType}
                                    isComingSoon={account.isComingSoon}
                                />
                            </IonCol>
                        ))}
                </IonRow>
            </IonGrid>
        </div>
    );
}
